var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { GetSmartFilterResults } from '../../apis/get-smart-filter-results-api';
import _ from 'lodash';
let SmartFilterRepositoryImpl = class SmartFilterRepositoryImpl {
    constructor(getSmartFilterResultsApi) {
        this.getSmartFilterResultsApi = getSmartFilterResultsApi;
    }
    async getSmartFilterResults(sfqList) {
        const res = await this.getSmartFilterResultsApi.getSmartFilterInfos({ filter_ids: sfqList });
        const results = sfqList
            .filter(filterId => _.has(res, filterId))
            .map(filterId => {
            const response = res[filterId];
            return {
                filterId: response.filter_id,
                messageId: response.message_id,
                userInputText: response.context?.user_input || '',
                patents: (response.content || []).map(e => ({
                    patentId: e.patent_id,
                    pn: e.pn,
                    filterItem: e.filter_item,
                    filterReason: e.filter_reason,
                })),
                selected: response.selected.map(item => ({
                    type: item.filter_item,
                    count: item.count,
                })),
                selectedPatentPNs: response.context?.selected_patent_pns,
            };
        });
        return results;
    }
};
SmartFilterRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(GetSmartFilterResults)),
    __metadata("design:paramtypes", [typeof (_a = typeof GetSmartFilterResults !== "undefined" && GetSmartFilterResults) === "function" ? _a : Object])
], SmartFilterRepositoryImpl);
export { SmartFilterRepositoryImpl };
